import * as React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useCopSecurityService from "services/security/useCopSecurityService";

const LoginCallback: React.FC = () => {
  const securityService = useCopSecurityService();

  const navigate = useNavigate();

  const params = window.location.search;

  useEffect(() => {
    async function handleCallback() {
      await securityService.handleLoginCallback();
    }
    // there's a difficult to reproduce bug that will sometimes cause the app to hang on the login callback screen.
    // This attempts to address but a better fix should be looked into later.
    if (!params) {
      navigate("/");
    } else {
      handleCallback();
    }
  }, [params]);

  return null;
};

export default LoginCallback;
